/**
 * Utility functions for Google Analytics tracking
 */

/**
 * Track a custom event in Google Analytics
 * @param {string} eventName - The name of the event (e.g., 'button_click', 'form_submit')
 * @param {Object} eventParams - Additional parameters for the event
 * @param {string} [eventParams.category] - Event category (e.g., 'engagement', 'error')
 * @param {string} [eventParams.label] - Event label (e.g., button name, form name)
 * @param {number} [eventParams.value] - Numeric value associated with the event
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, {
      ...eventParams,
      timestamp: new Date().toISOString(),
      app_version: process.env.REACT_APP_VERSION || '1.0.0',
    });
  }
};

/**
 * Track feature usage
 * @param {string} featureName - Name of the feature being used
 * @param {string} action - Action performed (e.g., 'start', 'stop', 'complete')
 */
export const trackFeatureUsage = (featureName, action) => {
  trackEvent('feature_usage', {
    category: 'engagement',
    label: featureName,
    action: action,
  });
};

/**
 * Track error events
 * @param {string} errorType - Type of error (e.g., 'runtime', 'api', 'validation')
 * @param {string} errorMessage - Error message
 * @param {string} [componentName] - Component where error occurred
 */
export const trackError = (errorType, errorMessage, componentName = 'unknown') => {
  trackEvent('error', {
    category: 'error',
    label: errorType,
    value: 1,
    error_message: errorMessage,
    component: componentName,
  });
};

/**
 * Track form submissions
 * @param {string} formName - Name of the form
 * @param {boolean} success - Whether the submission was successful
 */
export const trackFormSubmission = (formName, success) => {
  trackEvent('form_submission', {
    category: 'engagement',
    label: formName,
    success: success,
  });
}; 